import { ColorPreset } from './generic-colorpreset.component';

/**
 * Default color presets with matching text colors
 */
export const DEFAULT_TAG_COLOR_PRESETS: ColorPreset[] = [
    { tagColor: '#e6e6e6', tagTextColor: '#3d3d3d', label: 'Light Gray', value: 'light-gray' },
    { tagColor: '#ffcfc9', tagTextColor: '#b10202', label: 'Light Red', value: 'light-red' },
    { tagColor: '#ffc8aa', tagTextColor: '#753800', label: 'Light Orange', value: 'light-orange' },
    { tagColor: '#ffe5a0', tagTextColor: '#473822', label: 'Light Yellow', value: 'light-yellow' },
    { tagColor: '#d4edbc', tagTextColor: '#11734b', label: 'Light Green', value: 'light-green' },
    { tagColor: '#bfe1f6', tagTextColor: '#0a53a8', label: 'Light Blue', value: 'light-blue' },
    { tagColor: '#c6dbe1', tagTextColor: '#215a6c', label: 'Light Teal', value: 'light-teal' },
    { tagColor: '#e6cff2', tagTextColor: '#5a3286', label: 'Light Purple', value: 'light-purple' },
    { tagColor: '#3d3d3d', tagTextColor: '#e6e6e6', label: 'Dark Gray', value: 'dark-gray' },
    { tagColor: '#b10202', tagTextColor: '#ffcfc9', label: 'Dark Red', value: 'dark-red' },
    { tagColor: '#753800', tagTextColor: '#ffc8aa', label: 'Dark Orange', value: 'dark-orange' },
    { tagColor: '#473822', tagTextColor: '#ffe5a0', label: 'Dark Yellow', value: 'dark-yellow' },
    { tagColor: '#11734b', tagTextColor: '#d4edbc', label: 'Dark Green', value: 'dark-green' },
    { tagColor: '#0a53a8', tagTextColor: '#bfe1f6', label: 'Dark Blue', value: 'dark-blue' },
    { tagColor: '#215a6c', tagTextColor: '#c6dbe1', label: 'Dark Teal', value: 'dark-teal' },
    { tagColor: '#5a3286', tagTextColor: '#e6cff2', label: 'Dark Purple', value: 'dark-purple' },
];
